module.exports = __webpack_public_path__ + "img/lucky_icon.d73d5167.png";